export default class ILogger {
  static get WARNING () {
    return 'warning'
  }

  static get ERROR () {
    return 'error'
  }

  static get DEBUG () {
    return 'debug'
  }

  static get INFO () {
    return 'info'
  }

  error () {
    throw new Error(`Class must implement method 'error'`)
  }

  warning () {
    throw new Error(`Class must implement method 'warning'`)
  }

  info () {
    throw new Error(`Class must implement method 'info`)
  }

  debug () {
    throw new Error(`Class must implement method 'debug`)
  }
}



// WEBPACK FOOTER //
// ./src/utils/Logger/ILogger.js